import { PutObjectCommand, S3Client } from '@aws-sdk/client-s3'
import { fetchAuthSession } from 'aws-amplify/auth'

import config from '../../config'

export const Storage = () => {
  const client = new S3Client({
    region: import.meta.env.VITE_REGION,
    credentials: fetchAuthSession().then((session) => session.credentials) as any,
  })

  const put = async (key: string, data: any, options?: any) => {
    const body =
      typeof Blob !== 'undefined' && data instanceof Blob ? await data.arrayBuffer() : data
    const command = new PutObjectCommand({
      Bucket: options?.bucket || (config.s3.BUCKET as string),
      Key: key,
      Body: body,
    })

    try {
      return await client.send(command)
    } catch (err) {
      console.error('Detailed error: ', JSON.stringify(err, null, 2))
    }
  }

  return {
    put,
  }
}
